import { render, staticRenderFns } from "./folders.vue?vue&type=template&id=6eb52f57"
import script from "./folders.ts?vue&type=script&lang=js&external"
export * from "./folders.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports